var map = {
	"./1-en.png": "29Nr",
	"./1-fr.png": "q3bW",
	"./2-en.png": "BTs3",
	"./2-fr.png": "Qmv/",
	"./3-en.png": "m0T7",
	"./3-fr.png": "+uVW",
	"./4-en.png": "LPxX",
	"./4-fr.png": "CIiT",
	"./5-en.png": "E79t",
	"./5-fr.png": "k74d",
	"./6-en.png": "vEWY",
	"./6-fr.png": "3IDS",
	"./7-en.png": "ktGZ",
	"./7-fr.png": "NIJq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KjmJ";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img ^\.\/.*\.png$
// module id = KjmJ
// module chunks = 1